export default "__VITE_ASSET__7b34e106__"